import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Grid, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material'

import { useDispatch, useSelector } from 'react-redux'
import { getProjects, getProjectScenarios } from '../../../../actions'
import { variantTypes } from '../../../../constants'
import { FormTitle } from '../../../../components'
import { Logger, LoggerTypes } from '../../../../utils'
import './style.scss'

export const ScenarioImportForm = forwardRef(({ title, setOpenDialog, dispatchAction }, ref) => {
  const { t } = useTranslation()

  const projects = useSelector((state) => state.projects) || {}
  const currentProject = (projects && projects.currentProject) || null

  const [projectList, setProjectList] = useState(projects.items || [])
  const [selectedProject, setSelectedProject] = useState('')
  const [scenarios, setScenarios] = useState([])
  const [selectedScenario, setSelectedScenario] = useState('')
  const [errors, setErrors] = useState(null)
  const dispatch = useDispatch()

  Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioImportForm.INIT().then', {
    projects,
    currentProject
  })

  useEffect(() => {
    dispatch(getProjects())
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioImportForm.getProjects().then()', { projects, res })
        setProjectList(res.data)
        // checkSnackbarOK(enqueueSnackbar, t, res)
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, 'ScenarioImportForm.getProjects().catch()', { projects, res })
        // checkErrorResponse(res, enqueueSnackbar, t)
      })
  }, [])

  const onChangeProject = (e) => {
    const projectID = e.target.value
    dispatch(getProjectScenarios(projectID))
      .then((res) => {
        Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioImportForm.getProjectScenarios().then', {
          projectID,
          res,
          e
        })
        setScenarios(res)
        // checkSnackbarOK(enqueueSnackbar, t, res)
      })
      .catch((res) => {
        Logger.trace(LoggerTypes.WARN, 'ScenarioImportForm.getProjectScenarios().catch', {
          projectID,
          res
        })
        // checkErrorResponse(res, enqueueSnackbar, t)
      })
    Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioImportForm.onChangeProject()', { project: projectID })
    setSelectedProject(projectID)
  }

  const onChangeScenario = (e) => {
    const scenarioID = e.target.value
    Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioImportForm.onChangeScenario()', { scenario: scenarioID })
    setSelectedScenario(scenarioID)
  }

  // ----

  const onCloseDialog = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioImportForm.onCloseDialog()')
    setOpenDialog(false)
  }

  useImperativeHandle(ref, () => ({
    async onSubmitForm() {
      const targetProject = {
        project_id: currentProject?.id
      }

      dispatchAction(
        selectedProject,
        selectedScenario,
        targetProject,
        () => {
          Logger.trace(LoggerTypes.CONTROLLER, 'ScenarioImportForm.onSubmitForm()._onSuccess()', {
            currentProject,
            selectedProject,
            selectedScenario,
            targetProject
          })
          onCloseDialog()
        },
        (_errors) => {
          Logger.trace(LoggerTypes.WARN, 'ScenarioImportForm.onSubmitForm()._onFail()', { _errors })
          setErrors(_errors)
        }
      )
    }
  }))

  Logger.trace(LoggerTypes.CONTAINER, 'ScenarioImportForm.render()', {
    values: { selectedProject, selectedScenario }
  })

  return (
    <div className="ScenarioImportForm">
      <FormTitle title={title} />
      <form>
        <Grid container spacing={2} className="formContainer">
          {/*  Project  */}
          <Grid item xs={12} sm={12}>
            <FormControl error={Boolean(errors && errors?.status)} className="common_fullwidth">
              <InputLabel id="status-label" style={{ backgroundColor: 'white', padding: '0 5px' }}>
                {t('Select a project')}
              </InputLabel>
              <Select
                labelId="status-label"
                className="common_fullwidth"
                value={selectedProject}
                variant={variantTypes.OUTLINED}
                onChange={onChangeProject}
              >
                {Object.values(projectList)
                  .filter((project) => project.id !== currentProject.id)
                  .map((project, index) => (
                    <MenuItem key={index} value={project.id}>
                      {String(project.name)}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText>{(errors && errors?.status) || ''}</FormHelperText>
            </FormControl>
          </Grid>

          {/*  Scenarios  */}
          <Grid item xs={12} sm={12}>
            <FormControl error={Boolean(errors && errors?.phase)} className="common_fullwidth">
              <InputLabel id="phase-label" style={{ backgroundColor: 'white', padding: '0 5px' }}>
                {t('Matching scenarios')}
              </InputLabel>
              <Select
                labelId="phase-label"
                id="phase"
                className="common_fullwidth"
                value={selectedScenario}
                variant={variantTypes.OUTLINED}
                onChange={onChangeScenario}
              >
                {Object.values(scenarios).map((scenario, index) => (
                  <MenuItem key={index} value={scenario.id}>
                    {String(scenario.name)}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{(errors && errors?.phase) || ''}</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      </form>
    </div>
  )
})

ScenarioImportForm.displayName = 'ScenarioImportForm'

ScenarioImportForm.propTypes = {
  title: PropTypes.string,
  setOpenDialog: PropTypes.func.isRequired,
  dispatchAction: PropTypes.func.isRequired
}

ScenarioImportForm.defaultProps = {
  title: null,
  setOpenDialog: () => {},
  dispatchAction: () => {}
}
